import { useEffect } from 'react';

const setLink = (rel, href, hreflang) => {
  const sel = hreflang ? `link[rel="${rel}"][hreflang="${hreflang}"]` : `link[rel="${rel}"]`;
  let el = document.querySelector(sel);
  if (!el) {
    el = document.createElement('link');
    el.setAttribute('rel', rel);
    if (hreflang) el.setAttribute('hreflang', hreflang);
    el.setAttribute('data-seo', '1');
    document.head.appendChild(el);
  }
  el.setAttribute('href', href);
};

const setMeta = (attr, key, value) => {
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) { el = document.createElement('meta'); el.setAttribute(attr, key); document.head.appendChild(el); }
  el.setAttribute('content', value);
};

const DEFAULT_DESC = 'CAB.TAXI – Flughafentaxi & Transfer Zürich zum Festpreis. Flugverfolgung, Meet & Greet, 24/7. Zürich (ZRH), Basel (BSL), Genf (GVA) und die ganze Schweiz.';
const RTL = ['ar', 'he', 'fa', 'ku'];

// Canonical form of a path: lowercase, no trailing slash (except root), no query/hash.
export const canonicalPath = (p) => {
  let out = (p || '/').split('?')[0].split('#')[0].toLowerCase();
  if (out.length > 1) out = out.replace(/\/+$/, '');
  return out || '/';
};

// Lightweight SEO: title, description, canonical (default = normalized current URL), Open Graph/Twitter sync,
// optional hreflang alternates, robots noindex and <html lang/dir>.
export default function useSEO(title, description, opts) {
  const alt = opts && opts.alternates ? JSON.stringify(opts.alternates) : '';
  const canonical = opts && opts.canonical;
  const lang = opts && opts.lang;
  const dir = opts && opts.dir;
  const noindex = !!(opts && opts.noindex);
  const image = opts && opts.image;
  const skip = !!(opts && opts.skip);
  useEffect(() => {
    if (skip) return;
    const t = title || 'CAB.TAXI | Airport Taxi & Transfer Zürich';
    const d = (description && description.trim()) || DEFAULT_DESC;
    document.title = t;
    setMeta('name', 'description', d);
    setMeta('property', 'og:title', t);
    setMeta('property', 'og:description', d);
    setMeta('name', 'twitter:title', t);
    setMeta('name', 'twitter:description', d);
    const url = canonical || `${window.location.origin}${canonicalPath(window.location.pathname)}`;
    setMeta('property', 'og:url', url);
    if (image) { setMeta('property', 'og:image', image.startsWith('http') ? image : `${window.location.origin}${image}`); }
    setMeta('name', 'robots', noindex ? 'noindex, nofollow' : 'index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1');
    document.querySelectorAll('link[data-seo]').forEach((n) => n.remove());
    setLink('canonical', url);
    if (alt) JSON.parse(alt).forEach((a) => setLink('alternate', a.href, a.lang));
    const ui = localStorage.getItem('att_content_lang') || 'de';
    const l = lang || ui;
    document.documentElement.lang = l;
    document.documentElement.dir = dir || (RTL.includes(l) ? 'rtl' : 'ltr');
    setMeta('property', 'og:locale', { de: 'de_CH', en: 'en_GB', fr: 'fr_CH', it: 'it_CH' }[l] || l);
    window.scrollTo(0, 0);
  }, [title, description, alt, canonical, lang, dir, noindex, image, skip]);
}
